import { render, staticRenderFns } from "./ClassAdmin.vue?vue&type=template&id=0278dcb0&"
import script from "./ClassAdmin.vue?vue&type=script&lang=js&"
export * from "./ClassAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports